import { render, staticRenderFns } from "./modify-network.vue?vue&type=template&id=3521054c&scoped=true&"
import script from "./modify-network.vue?vue&type=script&lang=ts&"
export * from "./modify-network.vue?vue&type=script&lang=ts&"
import style0 from "./modify-network.vue?vue&type=style&index=0&id=3521054c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521054c",
  null
  
)

export default component.exports